import { Link } from "react-router-dom";
import helpchat from "../../../../assets/icons/helpchat.png";
import sizeguide from "../../../../assets/icons/sizeguide.png";
import styleguide from "../../../../assets/icons/styleguild.png";

const guides = [
    { to: "/faq", img: helpchat, label: "FAQs" },
    { to: "/size-guide", img: sizeguide, label: "Size Guide" },
    { to: "/style-guide", img: styleguide, label: "Style Guide" },
];

export default function HelpGuides() {
    return (
        <section className="help-guides">
            <h2
                className="help-guides-title"
                style={{ fontWeight: 400, fontSize: "32px" }}
            >
                Instant Help Guides
            </h2>
            <div className="guides-container">
                {guides.map(({ to, img, label }) => (
                    <div className="guide-item" key={to}>
                        <Link to={to}>
                            <img src={img} alt={`${label} Icon`} />
                            <p>{label}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    );
}
